// Travel Kit - Plantilla reutilizable para cada viaje
// Un espacio personal con herramientas prácticas: checklists, notas, presupuesto, itinerario

const travelKitData = {
	id: "travelkit",
	name: "Travel Kit",
	description:
		"Organiza tu maleta, presupuesto, itinerario y notas en un solo lugar",
	category: "travelkit",
	backgroundColor: "#F8FAFC",
	textColor: "#1E293B",
	headerBackgroundColor: "#06B6D4",
	headerTextColor: "#FFFFFF",
	fontFamily: "Poppins",
	tags: ["Utilidad", "Organización", "Reutilizable"],
	coverImage: "/images/travelkit/cover.svg",
	days: null, // No aplica para Travel Kit
	pages: [
		// Página 1: Portada
		{
			templateId: 101,
			order: 0,
			images: [null, null, null, null, null],
			texts: [{ content: "Mi Viaje", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				tripName: "Mi Viaje",
				destination: "Destino",
				startDate: "",
				endDate: "",
				travelers: "2 viajeros",
			},
		},
		// Página 2: Info Básica
		{
			templateId: 102,
			order: 1,
			images: [null, null, null, null, null],
			texts: [{ content: "Info del Viaje", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				sections: [
					{
						id: 1,
						type: "flight",
						title: "Vuelo de ida",
						icon: "✈️",
						color: "#3B82F6",
						fields: [
							{ label: "Aerolínea", value: "" },
							{ label: "Nº Vuelo", value: "" },
							{ label: "Fecha", value: "" },
							{ label: "Hora salida", value: "" },
							{ label: "Aeropuerto origen", value: "" },
							{ label: "Aeropuerto destino", value: "" },
							{ label: "Localizador", value: "" },
						],
					},
					{
						id: 2,
						type: "flight",
						title: "Vuelo de vuelta",
						icon: "✈️",
						color: "#3B82F6",
						fields: [
							{ label: "Aerolínea", value: "" },
							{ label: "Nº Vuelo", value: "" },
							{ label: "Fecha", value: "" },
							{ label: "Hora salida", value: "" },
							{ label: "Aeropuerto origen", value: "" },
							{ label: "Aeropuerto destino", value: "" },
							{ label: "Localizador", value: "" },
						],
					},
					{
						id: 3,
						type: "hotel",
						title: "Alojamiento",
						icon: "🏨",
						color: "#10B981",
						fields: [
							{ label: "Nombre", value: "" },
							{ label: "Dirección", value: "" },
							{ label: "Check-in", value: "" },
							{ label: "Check-out", value: "" },
							{ label: "Nº Reserva", value: "" },
							{ label: "Teléfono", value: "" },
						],
					},
					{
						id: 4,
						type: "contact",
						title: "Contactos de emergencia",
						icon: "📞",
						color: "#EF4444",
						fields: [
							{ label: "Embajada", value: "" },
							{ label: "Seguro de viaje", value: "" },
							{ label: "Contacto local", value: "" },
							{ label: "Emergencias", value: "112" },
						],
					},
				],
			},
		},
		// Página 3: Checklist Maleta
		{
			templateId: 103,
			order: 2,
			images: [null, null, null, null, null],
			texts: [{ content: "Mi Maleta", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				categories: [
					{
						id: 1,
						name: "Ropa",
						emoji: "👕",
						color: "#E8B4BC",
						items: [
							{ id: 1, text: "Camisetas / tops", checked: false, quantity: "" },
							{
								id: 2,
								text: "Pantalones / faldas",
								checked: false,
								quantity: "",
							},
							{ id: 3, text: "Ropa interior", checked: false, quantity: "" },
							{ id: 4, text: "Calcetines", checked: false, quantity: "" },
							{ id: 5, text: "Pijama", checked: false, quantity: "" },
							{
								id: 6,
								text: "Chaqueta / abrigo",
								checked: false,
								quantity: "",
							},
							{ id: 7, text: "Calzado cómodo", checked: false, quantity: "" },
						],
					},
					{
						id: 2,
						name: "Aseo",
						emoji: "🧴",
						color: "#C5E8D4",
						items: [
							{
								id: 1,
								text: "Cepillo y pasta de dientes",
								checked: false,
								quantity: "",
							},
							{ id: 2, text: "Champú / gel", checked: false, quantity: "" },
							{ id: 3, text: "Desodorante", checked: false, quantity: "" },
							{ id: 4, text: "Crema hidratante", checked: false, quantity: "" },
							{ id: 5, text: "Protector solar", checked: false, quantity: "" },
							{ id: 6, text: "Medicamentos", checked: false, quantity: "" },
						],
					},
					{
						id: 3,
						name: "Electrónica",
						emoji: "📱",
						color: "#D4B8E8",
						items: [
							{ id: 1, text: "Cargador móvil", checked: false, quantity: "" },
							{ id: 2, text: "Power bank", checked: false, quantity: "" },
							{
								id: 3,
								text: "Adaptador de enchufe",
								checked: false,
								quantity: "",
							},
							{ id: 4, text: "Auriculares", checked: false, quantity: "" },
							{ id: 5, text: "Cámara de fotos", checked: false, quantity: "" },
						],
					},
					{
						id: 4,
						name: "Documentos",
						emoji: "📄",
						color: "#F5E6C8",
						items: [
							{ id: 1, text: "Pasaporte / DNI", checked: false, quantity: "" },
							{
								id: 2,
								text: "Tarjetas de embarque",
								checked: false,
								quantity: "",
							},
							{
								id: 3,
								text: "Reservas impresas",
								checked: false,
								quantity: "",
							},
							{ id: 4, text: "Seguro de viaje", checked: false, quantity: "" },
							{
								id: 5,
								text: "Carnet de conducir",
								checked: false,
								quantity: "",
							},
						],
					},
					{
						id: 5,
						name: "Extras",
						emoji: "🎒",
						color: "#A8D5BA",
						items: [
							{ id: 1, text: "Gafas de sol", checked: false, quantity: "" },
							{ id: 2, text: "Libro / kindle", checked: false, quantity: "" },
							{ id: 3, text: "Snacks", checked: false, quantity: "" },
							{ id: 4, text: "Botella de agua", checked: false, quantity: "" },
						],
					},
				],
			},
		},
		// Página 4: Presupuesto
		{
			templateId: 104,
			order: 3,
			images: [null, null, null, null, null],
			texts: [{ content: "Presupuesto", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				currency: "€",
				totalBudget: 0,
				categories: [
					{
						id: 1,
						name: "Transporte",
						emoji: "✈️",
						color: "#3B82F6",
						expenses: [],
					},
					{
						id: 2,
						name: "Alojamiento",
						emoji: "🏨",
						color: "#10B981",
						expenses: [],
					},
					{
						id: 3,
						name: "Comida",
						emoji: "🍜",
						color: "#F59E0B",
						expenses: [],
					},
					{
						id: 4,
						name: "Actividades",
						emoji: "🎢",
						color: "#8B5CF6",
						expenses: [],
					},
					{
						id: 5,
						name: "Compras",
						emoji: "🛍️",
						color: "#EC4899",
						expenses: [],
					},
					{
						id: 6,
						name: "Otros",
						emoji: "📦",
						color: "#64748B",
						expenses: [],
					},
				],
			},
		},
		// Página 5: Notas Rápidas
		{
			templateId: 105,
			order: 4,
			images: [null, null, null, null, null],
			texts: [{ content: "Notas Rápidas", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				notes: [
					{
						id: 1,
						title: "Frases útiles",
						content:
							"• Hola / Gracias / Por favor\n• ¿Cuánto cuesta?\n• ¿Dónde está...?",
						color: "#FEF3C7",
						pinned: true,
					},
					{
						id: 2,
						title: "WiFi & Contraseñas",
						content: "Hotel: \nRestaurante: ",
						color: "#DBEAFE",
						pinned: false,
					},
					{
						id: 3,
						title: "Direcciones importantes",
						content: "• Hotel:\n• Embajada:\n• Hospital cercano:",
						color: "#FCE7F3",
						pinned: false,
					},
					{
						id: 4,
						title: "Cosas que quiero probar",
						content: "• \n• \n• ",
						color: "#D1FAE5",
						pinned: false,
					},
				],
			},
		},
		// Página 6: Itinerario
		{
			templateId: 106,
			order: 5,
			images: [null, null, null, null, null],
			texts: [{ content: "Mi Itinerario", isEditing: false }],
			maps: ["", "", ""],
			transport: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
			data: {
				days: [
					{
						id: 1,
						date: "",
						label: "Día 1",
						activities: [
							{
								id: 1,
								time: "09:00",
								activity: "Llegada",
								location: "",
								emoji: "✈️",
							},
							{
								id: 2,
								time: "12:00",
								activity: "Check-in hotel",
								location: "",
								emoji: "🏨",
							},
						],
					},
					{
						id: 2,
						date: "",
						label: "Día 2",
						activities: [],
					},
					{
						id: 3,
						date: "",
						label: "Día 3",
						activities: [],
					},
				],
			},
		},
	],
};

export default travelKitData;
